import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.json.stringify.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "supplier-info"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "团队基础信息", -1);

const _hoisted_4 = {
  class: "main1"
};
const _hoisted_5 = {
  class: "item1"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "item-project"
}, "项目名称：", -1);

const _hoisted_7 = {
  class: "main2"
};
const _hoisted_8 = {
  class: "item2"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "item-branch"
}, "关联发货方：", -1);

const _hoisted_10 = /*#__PURE__*/_createTextVNode("新增团队");

const _hoisted_11 = {
  style: {
    "margin-top": "10px"
  }
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_13 = {
  class: "supplier-setting"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "团队基础设置", -1);

const _hoisted_15 = {
  class: "prod"
};

const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "商品设置", -1);

const _hoisted_17 = {
  key: 0,
  class: "detail"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode("选择商品");

const _hoisted_19 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_20 = /*#__PURE__*/_createTextVNode("同步商业公司商品价格");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("自主定价（首次上架获取，后续不同步）");

const _hoisted_22 = {
  class: "owner"
};

const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "货位发货仓设置", -1);

const _hoisted_24 = {
  key: 0,
  class: "detail"
};

const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 新增 ");

const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_27 = {
  class: "custom-pager"
};
const _hoisted_28 = {
  class: "footer"
};

const _hoisted_29 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_30 = /*#__PURE__*/_createTextVNode("确定");

const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 取消 ");

const _hoisted_32 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { getDistributorList, getSysAreaTree, sellingDrugsList } from '@/request';
import { useRoute, useRouter } from 'vue-router';
import BatchAddDrugsModal from './BatchAddDrugsModal.vue';
import BatchAddSupplierOwnerModal from './BatchAddSupplierOwnerModal.vue';
import { ElMessage } from 'element-plus';
export default {
  name: 'BatchAddControlSalesTeamModal',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const tabsList = computed(() => store.state.router.tabsList);
    const disabled = ref(false);
    const addSupplier = ref({
      addSupplierCountModel: false,
      addSupplierCount: 0
    }); // 项目名称

    const prodjectName = ref(''); // 选择的商业公司ID

    const branchIds = ref([]); // 新增商品弹框

    const showBatchAddDrugsModal = ref(false);
    const addDrugsBranchIds = ref(''); // 商业公司列表

    const branchList = ref([]); // 团队阶梯表格

    const tableData = ref([]); // 价格同步策略(1-同商业公司；2-自主定价)

    const priceSyncStrategy = ref(1); // 商品表格

    const prodTable = ref();
    const prodTableShow = ref(true);
    const prodTableOptions = {
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '商品编号',
        field: 'prodNo',
        width: '200px',
        showOverflow: true
      }, {
        title: '商品名称',
        field: 'prodName',
        width: '200px',
        showOverflow: true
      }, {
        title: '规格',
        field: 'prodSpecification',
        width: '300px',
        showOverflow: true
      }, {
        title: '厂家',
        field: 'manufacturer',
        width: '300px',
        showOverflow: true
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      pagerConfig: {
        pageSizes: [10, 50, 100, 200],
        currentPage: 1,
        total: 10
      }
    };
    const prodTableData = ref([]); // 货位表格

    const ownerTable = ref();
    const addOwnerBranchIds = ref('');
    const showBatchAddOwnerModal = ref(false);
    const ownerTableShow = ref(true);
    const ownerTableOptions = {
      columns: [{
        title: '货位号',
        field: 'ownerId',
        width: '150px',
        showOverflow: true
      }, {
        title: '货位名称',
        field: 'ownerName',
        width: '120px',
        showOverflow: true
      }, {
        title: '所属仓库',
        field: 'wareHouseName',
        width: '100px',
        showOverflow: true
      }, {
        title: '商业',
        field: 'branchName',
        width: '200px',
        showOverflow: true
      }, {
        title: '默认',
        width: '100px',
        field: 'isDefault',
        showOverflow: true,
        type: 'checkbox'
      }, {
        title: '操作',
        width: '100px',
        field: 'ownerOperation',
        fixed: 'right',
        slots: {
          default: 'ownerOperation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      }
    };
    const ownerPageConfig = ref({
      currentPage: 1,
      pageSize: 5
    });
    const ownerTableData = computed(() => {
      const start = (ownerPageConfig.value.currentPage - 1) * ownerPageConfig.value.pageSize;
      const end = start + ownerPageConfig.value.pageSize;
      return orignOwnerTableData.value.slice(start, end);
    });

    const ownerPageChange = ({
      currentPage,
      pageSize
    }) => {
      ownerPageConfig.value.currentPage = currentPage;
      ownerPageConfig.value.pageSize = pageSize;
    };

    const orignOwnerTableData = ref([]);
    const areaLevels = [{
      label: '全国团队',
      value: 'country'
    }, {
      label: '大区团队',
      value: 'region'
    }, {
      label: '省级团队',
      value: 'province'
    }, {
      label: '市级团队',
      value: 'city'
    }, {
      label: '区县级团队',
      value: 'district'
    }];
    const cascaderProps = {
      multiple: true,
      label: 'text',
      value: 'id',
      emitPath: true,
      checkStrictly: false
    };
    const dictList = ref([]);

    function getTreeData() {
      return getSysAreaTree({
        adCode: 100000
      }).then(res => {
        let {
          success,
          data
        } = res;
        dictList.value = success ? data : [];
      });
    }

    function getBranchList() {
      let supplierCategory = route.query.supplierCategory;
      getDistributorList({
        page: 1,
        rows: 1000,
        supplierCategory: supplierCategory
      }).then(data => {
        let resBranchList = data.rows.map(item => {
          let branch = {
            branchId: item.branchId,
            branchName: item.branchName
          };
          return branch;
        });
        branchList.value = resBranchList;
      });
    }

    function addSupplierList() {
      console.log("addSupplierCount,", addSupplier.value.addSupplierCount);
      let addSupplierCount = addSupplier.value.addSupplierCount;
      let supplierCategory = route.query.supplierCategory;
      console.log('supplierCategory', supplierCategory);
      let supplierCategoryName = '商业流向管控团队';

      if (parseInt(supplierCategory) === 2) {
        supplierCategoryName = "销售团队";
      }

      for (var i = 1; i <= addSupplierCount; i++) {
        let supplier = {
          level: i,
          suppierName: '',
          supplierCategoryName: supplierCategoryName,
          areaLevel: '',
          areaCode: '',
          linkMan: '',
          linkPhone: ''
        };
        tableData.value.push(supplier);
      }

      addSupplier.value.addSupplierCountModel = false;
    }

    function deleteSupplierRow(row) {
      console.log('row', row);
      let level = row.level;
      tableData.value.splice(level - 1, 1);
    } // 批量添加商品


    function showBatchAddDrugs() {
      if (branchIds.value.length <= 0) {
        ElMessage.warning('请先选择关联发货方!');
        return;
      }

      let theBranchIds = branchIds.value.join(",");
      console.log('theBranchIds', theBranchIds);
      addDrugsBranchIds.value = theBranchIds;
      showBatchAddDrugsModal.value = true;
    }

    function batchAddDrugs(data) {
      let prodData = data.map(item => {
        let res = {
          prodNo: item.prodNo,
          prodName: item.prodName,
          prodSpecification: item.prodSpecification,
          manufacturer: item.manufacturer
        };
        return res;
      });
      let theProdTableData = [];
      prodTableData.value.forEach(item => {
        theProdTableData.push(item);
      });
      prodData.forEach(item => {
        theProdTableData.push(item);
      });
      console.log('theProdTableData', JSON.stringify(theProdTableData));
      prodTableData.value = theProdTableData; // console.log('theProdTableData', JSON.stringify(prodData));
      // prodTableData.value = prodData;
    } // 批量添加货位


    function showBatchAddOwner() {
      if (branchIds.value.length <= 0) {
        ElMessage.warning('请先选择关联发货方!');
        return;
      }

      let theBranchIds = branchIds.value.join(",");
      console.log('theBranchIds', theBranchIds);
      addOwnerBranchIds.value = theBranchIds;
      showBatchAddOwnerModal.value = true;
    }

    function batchAddOwner(data) {
      console.log('theOwnerTableData', JSON.stringify(data));
      let ownerData = data.map(item => {
        let res = {
          ownerId: item.ownerId,
          ownerName: item.ownerName,
          branchId: item.branchId,
          isDefault: 0,
          wareHouseName: item.wareHouseName,
          branchName: item.branchName
        };
        return res;
      });
      let theOwnerTableData = [];
      orignOwnerTableData.value.forEach(item => {
        theOwnerTableData.push(item);
      });
      ownerData.forEach(item => {
        let newArray = theOwnerTableData.filter(ownerItem => item.ownerId === ownerItem.ownerId && item.ownerId === ownerItem.branchId);

        if (newArray.length === 0) {
          theOwnerTableData.push(item);
        }
      });
      orignOwnerTableData.value = theOwnerTableData;
    }

    function delOwnerRow(row) {
      let ownerId = row.ownerId;
      let branchId = row.branchId;
      let newArray = orignOwnerTableData.value.filter(item => item.ownerId !== ownerId && item.ownerId !== branchId);
      orignOwnerTableData.value = newArray;
    }

    function handleCheckboxChange({
      row,
      checked
    }) {
      console.log('Row changed:', row, 'Checked:', checked);

      if (checked) {
        row.isDefault = 1; // let orignOwnerData = []
        // orignOwnerTableData.value.forEach(item => {
        //   if (item.branchId === row.branchId) {
        //     if (item.ownerId === row.ownerId) {
        //       item.isDefault = 1;
        //     } else {
        //       item.isDefault = 0;
        //     }
        //   }
        //   orignOwnerData.push(item);
        // })
        // console.log('orignOwnerData',orignOwnerData);
        // orignOwnerTableData.value = orignOwnerData;
      } else {
        row.isDefault = 0;
      }
    }

    function cancel() {
      router.go(-1);
      let tabName = 'BatchControlSalesTeam';
      store.commit('router/updateTabsList', {
        tab: tabsList.value.find(i => i.name === tabName) || null,
        type: 'delete'
      });
    }

    function save() {
      // let theTableData = tableData.value;
      // let thePriceSyncStrategy = priceSyncStrategy.value;
      // console.log('tableData', JSON.stringify(theTableData));
      let ownerTableData = ownerTable.value.getTableData();
      console.log('ownerTableData', JSON.stringify(ownerTableData));
    }

    onMounted(() => {
      getBranchList();
      getTreeData();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_cascader = _resolveComponent("el-cascader");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_vxe_pager = _resolveComponent("vxe-pager");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_input, {
        modelValue: prodjectName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prodjectName.value = $event),
        disabled: disabled.value,
        placeholder: "填写其总项目名称"
      }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_select, {
        modelValue: branchIds.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => branchIds.value = $event),
        placeholder: "请选择",
        filterable: "",
        multiple: "",
        clearable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.branchId,
            label: item.branchName,
            value: item.branchId
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        style: {
          "margin-left": "10px"
        },
        type: "primary",
        onClick: _cache[2] || (_cache[2] = $event => addSupplier.value.addSupplierCountModel = true)
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_table, {
        data: tableData.value,
        style: {
          "width": "100%",
          "overflow-x": "auto"
        },
        maxHeight: "300px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "level",
          label: "序号",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "supplierName",
          label: "团队名称",
          width: "300"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            modelValue: scope.row.suppierName,
            "onUpdate:modelValue": $event => scope.row.suppierName = $event,
            disabled: disabled.value,
            placeholder: "填写团队名称"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "supplierCategoryName",
          label: "团队类型",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "areaLevel",
          label: "团队级别",
          width: "180"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_select, {
            modelValue: scope.row.areaLevel,
            "onUpdate:modelValue": $event => scope.row.areaLevel = $event,
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(areaLevels, item => {
              return _createVNode(_component_el_option, {
                label: item.label,
                value: item.value,
                key: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "areaCode",
          label: "业务区域",
          width: "220"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_cascader, {
            modelValue: scope.row.areaCode,
            "onUpdate:modelValue": $event => scope.row.areaCode = $event,
            options: dictList.value,
            props: cascaderProps,
            showAllLevels: true,
            size: "default",
            "collapse-tags": ""
          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "linkMan",
          label: "联系人",
          width: "220"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            modelValue: scope.row.linkMan,
            "onUpdate:modelValue": $event => scope.row.linkMan = $event,
            disabled: disabled.value,
            placeholder: "填写联系人"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "linkPhone",
          label: "联系电话",
          width: "220"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            modelValue: scope.row.linkPhone,
            "onUpdate:modelValue": $event => scope.row.linkPhone = $event,
            disabled: disabled.value,
            placeholder: "填写联系电话"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "operation",
          label: "操作",
          width: "120"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => deleteSupplierRow(scope.row)
          }, {
            default: _withCtx(() => [_hoisted_12]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_hoisted_16, prodTableShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_vxe_grid, _mergeProps(prodTableOptions, {
        ref_key: "prodTable",
        ref: prodTable,
        data: prodTableData.value,
        class: "drug-table"
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: showBatchAddDrugs
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[3] || (_cache[3] = () => {})
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 1
        }), _createVNode(_component_el_radio_group, {
          modelValue: priceSyncStrategy.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => priceSyncStrategy.value = $event),
          style: {
            "margin-left": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_20]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 2
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 16, ["data"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_hoisted_23, ownerTableShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_vxe_grid, _mergeProps({
        "row-id": "ownerId"
      }, ownerTableOptions, {
        ref_key: "ownerTable",
        ref: ownerTable,
        data: _unref(ownerTableData),
        onCheckboxChange: handleCheckboxChange,
        class: "drug-table"
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: showBatchAddOwner
        }, {
          default: _withCtx(() => [_hoisted_25]),
          _: 1
        })]),
        ownerOperation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => delOwnerRow(row)
        }, {
          default: _withCtx(() => [_hoisted_26]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16, ["data"]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_vxe_pager, {
        "current-page": ownerPageConfig.value.currentPage,
        "page-size": ownerPageConfig.value.pageSize,
        total: orignOwnerTableData.value.length,
        "page-sizes": [10, 20, 50, 100],
        layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'FullJump', 'Total'],
        onPageChange: ownerPageChange
      }, null, 8, ["current-page", "page-size", "total"])])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: cancel
      }, {
        default: _withCtx(() => [_hoisted_29]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [_hoisted_30]),
        _: 1
      })])]), _createVNode(_component_el_dialog, {
        modelValue: addSupplier.value.addSupplierCountModel,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => addSupplier.value.addSupplierCountModel = $event),
        title: "新增团队",
        width: "350px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => addSupplier.value.addSupplierCountModel = false)
        }, {
          default: _withCtx(() => [_hoisted_31]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: addSupplierList
        }, {
          default: _withCtx(() => [_hoisted_32]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: addSupplier.value.addSupplierCount,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => addSupplier.value.addSupplierCount = $event),
          min: 0,
          max: 50,
          "step-strictly": true
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(BatchAddDrugsModal, {
        modelValue: showBatchAddDrugsModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showBatchAddDrugsModal.value = $event),
        branchIds: addDrugsBranchIds.value,
        onSuccess: batchAddDrugs
      }, null, 8, ["modelValue", "branchIds"]), _createVNode(BatchAddSupplierOwnerModal, {
        modelValue: showBatchAddOwnerModal.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showBatchAddOwnerModal.value = $event),
        branchIds: addOwnerBranchIds.value,
        onSuccess: batchAddOwner
      }, null, 8, ["modelValue", "branchIds"])], 64);
    };
  }

};